import React from 'react'
import SUSUNIAHILLS  from "../images/RCC_form_2027.pdf";
import purulia from "../images/8th Adventure Course Form 2026.pdf";


function UpcomingEvents() {
  return (
    <div>
      <div className="krishnagrofficemaountainer">
        <div className="album py-2">
          <div className="container">
            <br />

  <h2 className='mb-2'><b style={{color:"#f8ca56"}}>UPCOMING EVENTS 1: </b> APPLICATION FORM FOR 8TH ADVENTURE COURSE
at Shirkabad, Purulia, West Bengal.
From 27/12/2026 To 30/12/2026</h2>
            <a href={purulia} target="_blank" rel="noopener noreferrer">
            <h4 style={{color:"#FFF"}}><b><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
</svg> Download Form</b></h4>
            </a>
            <br/>
            <h2 className='mb-2'><b style={{color:"#f8ca56"}}>UPCOMING EVENTS 2:</b>  APPLICATION FORM FOR 41ST ROCK CLIMBING COURSE AT SUSUNIA HILLS, BANKURA From 12/01/2027 To 15/01/2027.</h2>
            <a href={SUSUNIAHILLS} target="_blank" rel="noopener noreferrer">
            <h4 style={{color:"#FFF"}}><b><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
</svg> Download Form</b></h4>
            </a>
            <br/>
            
            {/* <h2><b><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-2-circle" viewBox="0 0 16 16">
  <path d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M6.646 6.24v.07H5.375v-.064c0-1.213.879-2.402 2.637-2.402 1.582 0 2.613.949 2.613 2.215 0 1.002-.6 1.667-1.287 2.43l-.096.107-1.974 2.22v.077h3.498V12H5.422v-.832l2.97-3.293c.434-.475.903-1.008.903-1.705 0-.744-.557-1.236-1.313-1.236-.843 0-1.336.615-1.336 1.306"/>
</svg> APPLICATION FORM FOR 40TH  ROCK CLIMBING COURSE AT SUSUNIA HILLS, BANKURA <a href={FOR40THROCKCLIMBING}>
  <button className='buttonfrom mt-2'><b>Download Form <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" class="bi bi-cloud-download" viewBox="0 0 16 16">
  <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383"/>
  <path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z"/>
</svg></b></button> </a>

            </b></h2> */}

            <br />
          </div>
        </div>

      </div>
    </div>
  )
}

export default UpcomingEvents